import { useMutation, useQueryClient } from '@tanstack/react-query';

import getLibraryItemInfo from '@/requests/library/getLibraryItemInfo';
import { setAppStore } from '@/store';
import buildInputsFromPreset from '@/utils/preset/buildInputsFromPreset';
import getOrFetchQuery from '@/utils/query/getOrFetchQuery';
import { Screen } from '@/types';

import type { Preset } from '@/types';

const useLibraryItemInfoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (slug: string) => {
      const presetKey = ['libraryItemInfo', slug];

      const preset = await getOrFetchQuery<Preset>({
        key: presetKey,
        queryClient,
        fetcher: async () => {
          const data = await getLibraryItemInfo(slug);
          if (!data) throw new Error('Failed to load library item');
          return data;
        },
      });

      const inputs = buildInputsFromPreset(preset);
      setAppStore({
        selectedPreset: { ...preset, slug },
        inputs,
        screen: Screen.Create,
        isPresetLoading: false,
      });

      return { preset, slug };
    },

    onMutate: () => {
      setAppStore({
        isPresetLoading: true,
        screen: Screen.Create,
      });
    },

    onError: () => {
      setAppStore({
        isPresetLoading: false,
        screen: Screen.Library,
      });
    },
  });
};

export default useLibraryItemInfoMutation;
